module.exports = __webpack_public_path__ + "static/media/check-icon.59a2da5a.svg";